import { Trans } from '@lingui/react/macro'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'designSystem/components/AlertDialog'
import { Button } from 'designSystem/components/Button'
import { Spinner } from 'designSystem/components/Spinner'
import React from 'react'

export const PhotoRemoveButton: React.FC<{
  removing?: boolean
  disabled?: boolean
  onRemove: () => void
}> = ({ removing = false, disabled = false, onRemove }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <Button type='button' variant='destructive' disabled={disabled}>
        {removing && <Spinner data-icon='inline-start' />}
        <Trans>Remove</Trans>
      </Button>
    </AlertDialogTrigger>
    <AlertDialogContent size='sm'>
      <AlertDialogHeader>
        <AlertDialogTitle>
          <Trans>Remove this photo?</Trans>
        </AlertDialogTitle>
        <AlertDialogDescription>
          <Trans>The photo will be removed from this Subject.</Trans>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>
          <Trans>Keep</Trans>
        </AlertDialogCancel>
        <AlertDialogAction variant='destructive' onClick={onRemove}>
          <Trans>Remove</Trans>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
)
